module.exports = __webpack_public_path__ + "static/media/chatbot-logo-bg.c2854fc2.jpg";